<template>
  <div>
    <v-row class="mx-1">
      <!--//* LW -->
      <v-col cols="12" md="2" sm="2">
        <base-title-bar
          elevation="3"
          class="text-center"
          color="blue white--text"
          label="LW"
        />
        <v-list dense elevation="2" rounded>
          <v-list-item>
            <!-- 1 -->
            <v-list-item-content class="text-center">
              <v-list-item-title>
                <!-- <p class="body-1 font-weight-bold">
                  C
                </p> -->

                <router-link
                  v-for="item in depthChart.FantasyPlayer.LWplayer"
                  :key="item._id"
                  :to="{
                    name: 'PlayerDetail',
                    params: { playerId: item.PlayerID, SportId: item.SportId },
                  }"
                  style="text-decoration: none"
                  class="body-2"
                >
                  <p>{{ item.FirstName }} {{ item.LastName }}</p>
                </router-link>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-col>
      <!--//* LW ends -->

      <!--//* C -->
      <v-col cols="12" md="2" sm="2">
        <base-title-bar
          elevation="3"
          class="text-center"
          color="blue white--text"
          label="C"
        />
        <v-list dense elevation="2" rounded>
          <v-list-item>
            <!-- 1 -->
            <v-list-item-content class="text-center">
              <v-list-item-title>
                <!-- <p class="body-1 font-weight-bold">
                  FS
                </p> -->

                <router-link
                  v-for="item in depthChart.FantasyPlayer.Cplayer"
                  :key="item._id"
                  :to="{
                    name: 'PlayerDetail',
                    params: { playerId: item.PlayerID, SportId: item.SportId },
                  }"
                  style="text-decoration: none"
                  class="body-2"
                >
                  <p>{{ item.FirstName }} {{ item.LastName }}</p>
                </router-link>
              </v-list-item-title>
            </v-list-item-content>
            <!-- //todo -->
          </v-list-item>
        </v-list>
      </v-col>
      <!--//* C ends -->

      <!--//* RW -->
      <v-col cols="12" md="2" sm="2">
        <base-title-bar
          elevation="3"
          class="text-center"
          color="blue white--text"
          label="RW"
        />
        <v-list dense elevation="2" rounded>
          <v-list-item>
            <!-- 1 -->
            <v-list-item-content class="text-center">
              <v-list-item-title>
                <!-- <p class="body-1 font-weight-bold">
                  FS
                </p> -->

                <router-link
                  v-for="item in depthChart.FantasyPlayer.RWplayer"
                  :key="item._id"
                  :to="{
                    name: 'PlayerDetail',
                    params: { playerId: item.PlayerID, SportId: item.SportId },
                  }"
                  style="text-decoration: none"
                  class="body-2"
                >
                  <p>{{ item.FirstName }} {{ item.LastName }}</p>
                </router-link>
              </v-list-item-title>
            </v-list-item-content>
            <!-- //todo -->
          </v-list-item>
        </v-list>
      </v-col>
      <!--//* RW ends -->

      <!--//* G -->
      <v-col cols="12" md="3" sm="3">
        <base-title-bar
          elevation="3"
          class="text-center"
          color="blue white--text"
          label="G"
        />
        <v-list dense elevation="2" rounded>
          <v-list-item>
            <!-- 1 -->
            <v-list-item-content class="text-center">
              <v-list-item-title>
                <!-- <p class="body-1 font-weight-bold">
                  FS
                </p> -->

                <router-link
                  v-for="item in depthChart.FantasyPlayer.Gplayer"
                  :key="item._id"
                  :to="{
                    name: 'PlayerDetail',
                    params: { playerId: item.PlayerID, SportId: item.SportId },
                  }"
                  style="text-decoration: none"
                  class="body-2"
                >
                  <p>{{ item.FirstName }} {{ item.LastName }}</p>
                </router-link>
              </v-list-item-title>
            </v-list-item-content>
            <!-- //todo -->
          </v-list-item>
        </v-list>
      </v-col>
      <!--//* G ends -->

      <!--//* D -->
      <v-col cols="12" md="3" sm="3">
        <base-title-bar
          elevation="3"
          class="text-center"
          color="blue white--text"
          label="D"
        />
        <v-list dense elevation="2" rounded>
          <v-list-item>
            <!-- 1 -->
            <v-list-item-content class="text-center">
              <v-list-item-title>
                <!-- <p class="body-1 font-weight-bold">
                  FS
                </p> -->

                <router-link
                  v-for="item in depthChart.FantasyPlayer.Dplayer"
                  :key="item._id"
                  :to="{
                    name: 'PlayerDetail',
                    params: { playerId: item.PlayerID, SportId: item.SportId },
                  }"
                  style="text-decoration: none"
                  class="body-2"
                >
                  <p>{{ item.FirstName }} {{ item.LastName }}</p>
                </router-link>
              </v-list-item-title>
            </v-list-item-content>
            <!-- //todo -->
          </v-list-item>
        </v-list>
      </v-col>
      <!--//* D ends -->
    </v-row>
  </div>
</template>

<script>
export default {
  name: "nhl-depthchart",
  props: {
    depthChart: {
      type: [Array, Object],
      default: () => [],
    },
  },
};
</script>

<style></style>
